import { render, staticRenderFns } from "./DavlatDasturi.vue?vue&type=template&id=4c8f5ca5&scoped=true&"
import script from "./DavlatDasturi.vue?vue&type=script&lang=js&"
export * from "./DavlatDasturi.vue?vue&type=script&lang=js&"
import style0 from "./DavlatDasturi.vue?vue&type=style&index=0&id=4c8f5ca5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c8f5ca5",
  null
  
)

export default component.exports